import React from 'react'
import Add from './add'
import { AccordionWithArrow } from '../../../../components'
import { Wrapper } from './style'

const CopyQuestion = () => {
  return (
    <Wrapper>
        <AccordionWithArrow title='Copy Questions and Sub Questions' expanded={true} accordionstyle='fieldset' showArrow={false}>
            <Add />
        </AccordionWithArrow>
    </Wrapper>
  )
}

export default CopyQuestion
